export default __webpack_public_path__ + "static/media/mitigation-basement-wide-drying-setup.c9098aa6.jpg";